import React, { useEffect, useState } from "react";
import logo from "./../img/logo.svg";
import CookiesPage from "./cookies.js";
import "./../css/header.scss";
// import { NavLink } from "react-router-dom";Col,
import { Nav, Navbar, NavDropdown, Row, Container } from "react-bootstrap";
const FrontHeader = () => {
  const [showProducts, setShowProducts] = useState(false);
  const [showLanguages, setShowLanguages] = useState(false);
  const [showCaseStudies, setShowCaseStudies] = useState(false);
  const [isCookies, setIsCookies] = useState(null);

  useEffect(()=>{

    // localStorage.setItem('isCookies', true);
    // localStorage.setItem('isUserEnter', true);
    setIsCookies(localStorage.getItem('isCookies'));
    //console.log('isCookies::',isCookies);
    if (isCookies) {
      
    }
  },[isCookies])

  const onChangeHandler = () => {
    localStorage.setItem('isCookies', true);
    setIsCookies(true);
  }

  return (
    <header className="header fixed-top bg-white">
      {
        isCookies === null ? 
        <CookiesPage isCookies={isCookies} onChangeHandler={onChangeHandler}/>
        : null
      }
      <Container className="pl-0 pr-0">
        <Row>
          <Navbar expand="lg" className="header-navbar">
            <Navbar.Brand href="/ua/">
              <img src={logo} alt=" " className="topLogo" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="navbar-right">
                <NavDropdown
                  className=""
                  title="Продукти"
                  id="basic-nav-dropdown-products"
                  show={showProducts}
                  onMouseEnter={()=>{setShowProducts(true)}} 
                  onMouseLeave={()=>{setShowProducts(false)}}
                >
                  <NavDropdown.Item href="/ua/product/online-insurance-products">
                    Страховий інтернет-магазин
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/ua/product/sagacity-insurance-api">
                    Платформа страхування Api
                  </NavDropdown.Item>
                </NavDropdown>
                <NavDropdown
                  className=""
                  title="Приклади рішень"
                  id="basic-nav-dropdown-case-studies"
                  show={showCaseStudies}
                  onMouseEnter={()=>{setShowCaseStudies(true)}} 
                  onMouseLeave={()=>{setShowCaseStudies(false)}}
                >
                  <NavDropdown.Item href="/ua/case-studies/chat-bots">
                    Чат-боти
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/ua/case-studies/online-store">
                    Онлайн-магазин
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/ua/case-studies/api-sales-tool">
                    API - Інструмент продажів
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/ua/case-studies/online-agent">
                    Онлайн-агент
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/ua/case-studies/mobile-app">
                    Мобільний додаток
                  </NavDropdown.Item>
                </NavDropdown>
                {/* <Nav.Link className="navLink" href="/ua/case-studies">
                  Case Studies
                </Nav.Link> */}
                <Nav.Link className="navLink" href="/ua/company">
                  Компанія
                </Nav.Link>
                <Nav.Link className="navLink" href="/ua/careers">
                  Кар'єра
                </Nav.Link>
                <Nav.Link className="navLink" href="/ua/blogs">
                  Блог
                </Nav.Link>
                <Nav.Link className="navLink navLinkEnd" href="/ua/contact">
                  Контакти
                </Nav.Link>
                <NavDropdown
                    className="basic-nav-dropdown-languages"
                    title="UA"
                    id="basic-nav-dropdown-languages"
                    show={showLanguages}
                    onMouseEnter={()=>{setShowLanguages(true)}}
                    onMouseLeave={()=>{setShowLanguages(false)}}
                >
                  <NavDropdown.Item href={location.pathname.replace(/\/ua\//gi, "/en/")}>
                    EN
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </Row>
      </Container>
    </header>
  );
};
export default FrontHeader;
